<template>
  <div class="base-header">
    <div class="btn">
      <van-icon name="bars" size="22" @click="ClickIcon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MineHeaderView',
  methods: {
    ClickIcon () {
      this.$emit('click-icon')
    }
  }
}
</script>
<style lang="scss" scoped>
.mine-header {
  padding: 8px 10px;
  background: #fff;
  display: flex;
  gap: 10px;
}
.btn {
  border-radius: 50%;
  background: #fff;
  padding: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
}
</style>
